import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generateApiPath } from 'src/utils';
import {
  API_GET_OMNIVERSE_APP,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_OMNIVERSE_APPLICATION,
} from '../constants';

interface ApiParams {
  solutionId: string;
  siteId: string;
  twinId: string;
  functionId?: string;
  functionVersionId?: string;
}

const api = ({
  solutionId,
  siteId,
  twinId,
  functionId,
  functionVersionId,
}: ApiParams) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generateApiPath(API_GET_OMNIVERSE_APP, { solutionId, siteId }),
    queryParams: {
      TwinId: twinId,
    },
  });

const omniverseApp = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_OMNIVERSE_APPLICATION,
  responseMapping: ResponseMapping.Default,
});

export default omniverseApp;
